import { PatientToDo } from 'kb-shared';
import { INTAKE_TODO_TITLE } from 'screens/Dashboard/ToDoWidget/ToDoItems/ToDoItems.utils';

export const hasIntakeTodo = (todos: PatientToDo[]): Boolean => {
  return todos.some(todo => todo.title === INTAKE_TODO_TITLE && !todo.completed);
};
